// A drop button reads its inactive text while the drop is not live, when it
// has one.
export const getDropButtonText = (
	showCardCartButton: boolean,
	button: null | {
		inactive_text?: string | null | undefined;
		button_text?: string | null | undefined;
	}
) => {
	return !showCardCartButton && button?.inactive_text
		? button?.inactive_text
		: button?.button_text;
};
